import { useAxios } from "./useAxios"
import { useBot } from "./useBot"

const axios = useAxios()

export interface Media {
    id: number
    uuid: string
    type: string
    source: string
    isThumb: boolean
    fileType: string
    fileOriginalName: string
    fileName: string
    placement?: string
    createdAt: Date
}

export function useMedia() {
    const { selectedBot } = useBot()

    const upload = async (file: File): Promise<Media> => {
        const formData = new FormData()
        formData.append('file', file)

        // let type = 'image';
        // if (file.type.startsWith('video')) type = 'video';
        // if (file.type.startsWith('audio')) type = 'audio';

        // formData.append('type', type);

        const response = await axios.post(`/chat-flow/bots/${selectedBot.value?.id}/media`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return response.data
    }

    return {
        upload
    }
}
